import { render, staticRenderFns } from "./LotGeneralInfo.vue?vue&type=template&id=700acb72&"
import script from "./LotGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./LotGeneralInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports